import Vue from "vue";
import ConfirmationModal from "~/components/modals/confirmationModal.vue";
import MultipleSubmissionsModal from "~/components/modals/multipleSubmissionsModal.vue";
import { ObjectModelActionType } from "~/enums/objectModelActionType";
import { ObjectModelDefaultActionTypeName } from "~/enums/objectModelDefaultActionType";
import { IConfirmModalConfig } from "~/interfaces/modalInterfaces";
import DetailView from "~/models/detailView/detailView";
import DetailViewContentElement from "~/models/detailView/elements/detailViewContentElement";
import ListViewContentElement from "~/models/listViews/elements/listViewContentElement";
import PublishedListView from "~/models/listViews/publishedListView";
import ObjectModel from "~/models/objectModel";
import PublishedObjectModel from "~/models/objectModels/publishedObjectModel";
import ActionConfirmationModal from '../components/content-view-action-confirmation-modal.vue';
import Selected from "../store/modules/selected";

export default Vue.extend({
  // LANE: address list view secondary header not needing capabilities of ActionConfirmationModal. Falling back to including reg. ConfirmationModal for now.
  components: {
    ActionConfirmationModal,
    ConfirmationModal,
    MultipleSubmissionsModal
  },
  data: function (): object {
    return {
      selectedObjectModelAction: null,
    }
  },
  created() {
    if (!this.isUserDashboard) this.checkRequirements();
  },
  computed: {
    relevantView(): DetailView | PublishedListView {
      return this.selectedDetailView || this.selectedPublishedListView || Selected.publishedListView.get();
    },
    relevantObjectModel(): ObjectModel | PublishedObjectModel {
      return this.relevantView.published_object_model ?? this.relevantView.object_model;
    },
    actionConfirmationModalConfig(): Partial<IConfirmModalConfig> {
      if (!this.selectedObjectModelAction.action_confirmation) return;

      const {header, body} = this.selectedObjectModelAction.action_confirmation;
      let affirmText = 'Confirm';
      if (this.selectedObjectModelAction.is(ObjectModelActionType.DefaultAction)) {
        const actionVerb = ObjectModelDefaultActionTypeName[this.selectedObjectModelAction.default_action_type];
        affirmText = `${actionVerb} Record`;
      }
      return {
        confirmationHeader: header,
        htmlSafeConfirmationMessage: body,
        affirmText,
      }
    },
  },
  methods: {
    checkRequirements(): void {
      if (!this.performSelectedAction) {
        throw new Error('performSelectedAction() method must be implemented in component.')
      }
      if (!this.isPreview && !this.relevantView) {
        throw new Error('Could not find relevant published content view.')
      }
    },
    tryPerformAction(action: DetailViewContentElement | ListViewContentElement | {action_client_id: string}, listView=null): void {
      if (listView) Selected.publishedListView.set(listView);
      this.selectedObjectModelAction = this.relevantObjectModel.findObjectModelAction(action.action_client_id);
      if (!this.selectedObjectModelAction) {
        // happens on embedded list views where the "relevant" object model is actually the OM for the outer detail view, not the embedded list view
        const model = ObjectModel.repo.findBy(om => {
          // object_model_id is used on published OMs to find the id of the unpublished one
          return om['object_model_id'] === this.entry.object_model_id || om.id === this.entry.object_model_id;
        });
        if (model) {
          this.selectedObjectModelAction = model.findObjectModelAction(action.action_client_id);
        } else {
          throw new Error('Could not find object model for entry');
        }
      }
      if (this.isOneStop &&
        this.selectedObjectModelAction.action_type === ObjectModelActionType.FillForm && 
        this.selectedUser.current_entity && 
        this.selectedUser.current_entity.submission_dictionary[this.selectedObjectModelAction.linked_form_id] &&
        this.selectedUser.current_entity.submission_dictionary[this.selectedObjectModelAction.linked_form_id].length > 0) {

        this.showModal(this.vueModalID.multipleSubmissions);
      } else if (this.selectedObjectModelAction.include_confirmation) {
        this.showModal(this.vueModalID.confirmObjectModelAction);
      } else {
        this.performSelectedAction();
        this.selectedObjectModelAction = null;
      }
    },
    handleCloseConfirmationModal(data) {
      this.hideModal(this.vueModalID.confirmObjectModelAction);
      const outcome = $(data.event.currentTarget).data('action');
      if (outcome === 'affirm') {
        this.performSelectedAction();
      }
      this.selectedObjectModelAction = null;
    },
    startForm() {
      this.hideModal(this.vueModalID.multipleSubmissions);
      if (this.selectedObjectModelAction) {
        this.performSelectedAction();
      }
      this.selectedObjectModelAction = null;
    },
    editForm() {
      this.hideModal(this.vueModalID.multipleSubmissions);
      if (this.selectedObjectModelAction && this.selectedUser.current_entity.submission_dictionary[this.selectedObjectModelAction.linked_form_id] && this.selectedUser.current_entity.submission_dictionary[this.selectedObjectModelAction.linked_form_id].length > 0) {
        const submission_id = this.selectedUser.current_entity.submission_dictionary[this.selectedObjectModelAction.linked_form_id][0]
        window.location.href = `/submissions/${submission_id}/edit`
      }
      this.selectedObjectModelAction = null;
    }
  },
});